import { defineStore } from 'pinia'
import { setLocale, fetchLocaleOptions, FALLBACK, toBCP47 } from '../i18n/index.js'

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        locale: FALLBACK,
        localeOptions: []
    }),
    actions: {
        async init(initial) {
            const saved = localStorage.getItem('sv-lang')
            const target = toBCP47(saved || this.locale || initial || FALLBACK)

            this.locale = await setLocale(target)

            this.localeOptions = await fetchLocaleOptions()
            if (!this.localeOptions.find(o => o.value === this.locale)) {
                this.localeOptions.unshift({ value: this.locale, label: this.locale })
            }
        },
        async changeLocale(next) {
            this.locale = await setLocale(next)
        }
    },
    persist: { key: 'sv.settings', paths: ['locale'], storage: localStorage }
})
